var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  d: "M14.667 3.113v8.047c0 .64-.52 1.24-1.16 1.32l-.22.027c-1.454.193-3.694.933-4.974 1.64A.6.6 0 0 1 8 14.22V3.533a.7.7 0 0 0 .353-.093l.114-.073c1.186-.747 3.313-1.46 4.713-1.58h.04a1.313 1.313 0 0 1 1.447 1.326",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  fillRule: "evenodd",
  d: "M8 3.533V14.22a.7.7 0 0 1-.327-.073l-.026-.014c-1.28-.7-3.514-1.433-4.96-1.626l-.194-.027c-.64-.08-1.16-.68-1.16-1.32V3.107c0-.794.647-1.394 1.44-1.327 1.4.113 3.52.82 4.707 1.56l.167.1c.1.06.226.093.353.093M5.167 6.16h-1.5a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h1.5c.273 0 .5.227.5.5s-.227.5-.5.5m-1.5 2h2c.273 0 .5-.227.5-.5s-.227-.5-.5-.5h-2c-.274 0-.5.227-.5.5s.226.5.5.5",
  clipRule: "evenodd"
})));
export { SvgLearn as ReactComponent };